import { useEffect, useState } from "react";

export const useAthleteVolumes = ({ prevFrom, athleteVolumes }) => {
  const [athleteVolumesState, setAthleteVolumesState] = useState([]);

  // Add the new loaded athlete volumes to the state
  // This happens when going back to previous months which don't have the athlete volumes loaded
  useEffect(() => {
    if (prevFrom) {
      let newVolumesState = Array.from(athleteVolumesState);
      newVolumesState = newVolumesState.concat(athleteVolumes);
      setAthleteVolumesState(newVolumesState);
      return;
    }
    setAthleteVolumesState(athleteVolumes);
  }, [athleteVolumes]);

  return {
    athleteVolumesState,
  };
};
